module.exports = __webpack_public_path__ + "img/photo-48.9e60584e.png";